import {
  AnalysisRuleRunStatusCell,
  DatasetsManagementCell,
  DescriptionCell,
  PublishStatusCell,
  QuestionOwnerCell,
  QuestionTypeCell,
  StatusCell,
  TagsCell,
} from 'components/CleanRooms/CurrentQuestions/QuestionsTableLayout/TableCellComponents';
import { cellTypesEnum } from 'BaseComponents';


export const getColumns = (analysisRuleEnabled) => [{
  field: 'displayID',
  name: 'Display Id',
  width: 140,
}, {
  field: 'title',
  name: 'Name',
  type: cellTypesEnum.LINE_3,
  width: 120,
}, {
  field: 'isUserListQuestion',
  name: 'Type',
  width: 70,
  component: QuestionTypeCell,
}, {
  field: 'cleanRoomQuestionOwner',
  name: 'Question Owner',
  width: 280,
  component: QuestionOwnerCell,
}, {
  field: '',
  name: 'Datasets',
  width: 225,
  component: DatasetsManagementCell,
},
{
  field: 'description',
  name: 'Description',
  width: 280,
  component: DescriptionCell,
}, {
  field: 'category',
  name: 'Category',
  width: 140,
}, {
  field: 'tags',
  name: 'Tags',
  width: 120,
  component: TagsCell,
}, {
  field: 'Created On',
  name: 'Date Created',
  width: 225,
  type: cellTypesEnum.US_DATE_FORMAT,
  valueGetter: ({ row }) => (row.timeAudit.createdAt),
}, {
  field: 'Last Modified Date',
  name: 'Date Modified',
  width: 225,
  type: cellTypesEnum.US_DATE_FORMAT,
  valueGetter: ({ row }) => (row.timeAudit.updatedAt),
}, {
  field: 'Publish Status',
  name: 'Publish Status',
  width: 120,
  component: PublishStatusCell,
}, analysisRuleEnabled && ({
  field: 'analysisRuleStatus',
  name: 'Analysis Rule Status',
  width: 160,
  component: AnalysisRuleRunStatusCell,
}), {
  field: 'status',
  name: 'Status',
  width: 120,
  component: StatusCell,
}].filter(Boolean);
